import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FeedbackModalComponent } from './feedback-modal.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [FeedbackModalComponent],
    imports: [CommonModule, IonicModule, TranslateModule],
    exports: [FeedbackModalComponent]
})
export class FeedbackModalModule {}
